import { Form, type FormItemProps, Input } from 'antd';
import type { FC } from 'react';
import type { EventDuplicateFormFields } from './EventDuplicateModal';

interface Props {
  oldEventName: string;
}

const hint = 'New event name needs to be different from original.';

export const NewEventNameField: FC<Props> = ({ oldEventName }) => {
  const rules: FormItemProps<EventDuplicateFormFields>['rules'] = [
    {
      required: true,
      message: 'Event name is required',
    },
    {
      validator: async (_, value) => {
        if (value === oldEventName) throw new Error(hint);
      },
    },
  ];

  return (
    <Form.Item name="newEventName" label="New Event Name" rules={rules}>
      <Input />
    </Form.Item>
  );
};

export const validate = (value: string, oldEventName: string): string => {
  if (oldEventName === value) {
    return 'The name of your new Tracking Map already exists. Please choose another name.';
  }
  if (value === '') {
    return 'Name is required';
  }
  return '';
};
